import { createFileRoute } from '@tanstack/react-router'
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from '@/components/ui/breadcrumb';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Separator } from '@/components/ui/separator';

import { Link } from '@tanstack/react-router'
import { EllipsisVerticalIcon } from 'lucide-react';
import MyTaskWidgetComponent from '@/components/my-tasks-widget/my-task-widget.component';
import RecentActivityComponent from '@/components/recent-activity-widget/recent-activity-widget.component';


export const Route = createFileRoute('/_app/home/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <>
        <div className="absolute left-12 top-0 h-full min-h-full w-[calc(100%-50px)]">
            <header
                className={`z-50 sticky top-0 flex shrink-0 items-center gap-2 p-2 bg-white border-b-4 border-b-blue-500`}
            >
                <div className="flex flex-1 items-center gap-2">
                    <Separator orientation="vertical" className="mr-2 h-4" />
                    <Breadcrumb>
                        <BreadcrumbList>
                            <BreadcrumbItem className="hidden md:block">
                                <BreadcrumbLink asChild>
                                    <Link to='/home'>
                                        Home
                                    </Link>
                                </BreadcrumbLink>
                            </BreadcrumbItem>

                            <BreadcrumbSeparator className="hidden md:block" />
                            <BreadcrumbItem>
                                <BreadcrumbPage>
                                    Dashboard
                                </BreadcrumbPage>
                            </BreadcrumbItem>
                        </BreadcrumbList>
                    </Breadcrumb>
                </div>
                <div className="flex items-center gap-2 ml-auto">
                    <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                            <Button variant="outline">
                                Actions <EllipsisVerticalIcon className="h-4 w-4" />
                            </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent>
                            <DropdownMenuLabel>Quick Actions</DropdownMenuLabel>
                            <DropdownMenuSeparator />





                        </DropdownMenuContent>
                    </DropdownMenu>



                </div>
            </header>

            <div className="flex flex-row h-full gap-5 p-5 bg-gray-100">


                <MyTaskWidgetComponent />
                <RecentActivityComponent />

            </div>
        </div>
    </>
}
